import { useState } from 'react';
import { withErrorBoundary } from '@sentry/react';
import { InsuranceType } from '@weave/schema-gen-ts/dist/schemas/insurance-verification/shared/enums.pb';
import { ErrorFallback } from '../components/error-fallback'; // Assuming this is your fallback component
import { InsuranceReportContainer } from '../containers/insurance-report-container';

type InsuranceReportPageProps = {
  reportProps: {
    locationId?: string;
    personInfo: {
      personId: string;
      personName: string;
    };
    sourceId?: string;
    personPMSId?: string;
    insuranceType?: InsuranceType;
    closeInsuranceReportModal?: () => void;
  };
};

const InsuranceReportPage = ({ reportProps }: InsuranceReportPageProps) => {
  const { locationId, personInfo, sourceId, personPMSId, insuranceType, closeInsuranceReportModal } = reportProps;

  const [shouldShowErrorFallback, setShouldShowErrorFallback] = useState<boolean>(false);

  if (shouldShowErrorFallback) {
    return <ErrorFallback />;
  }

  return (
    <InsuranceReportContainer
      reportProps={{
        locationId: locationId as string,
        personInfo,
        sourceId: sourceId ?? '',
        personPMSId: personPMSId ?? '',
        insuranceType: insuranceType as InsuranceType,
        closeInsuranceReportModal: closeInsuranceReportModal,
        onError: () => setShouldShowErrorFallback(true),
      }}
    />
  );
};

export const InsuranceReportPageWithErrorBoundary = withErrorBoundary(InsuranceReportPage, {
  fallback: <ErrorFallback />,
});
